export default function apiConfig(componentName = "", headers = {}, options = {}, apiUrl = undefined) {
  return { headers: { "x-component-name": componentName, ...headers }, apiUrl, options }
}